<template>
  <tm-list-frame></tm-list-frame>
</template>

<script>
import TmListFrame from "../../../components/mb/TmListFrame.vue";

export default {
  name: "mb-tm-list",
  components: {
    TmListFrame,
  },
  mounted() {
    this.$log.debug("[TmList] mounted()");
    /** 表示コンテンツのセット */
    this.$store.commit("app/setContent", "TmList");

    // パラメータによって初期表示するタブを変更
    let knd = this.$route.query["knd"];
    if (knd === "twn") {
      this.$store.commit("Telemeter/setSelectTmListTabIndex", 0);
    } else if (knd === "rsys") {
      this.$store.commit("Telemeter/setSelectTmListTabIndex", 1);
    } else if (knd === "stg") {
      this.$store.commit("Telemeter/setSelectTmListTabIndex", 2);
    } else if (knd === "rn") {
      this.$store.commit("Telemeter/setSelectTmListTabIndex", 3);
    } else if (knd === "swstg") {
      this.$store.commit("Telemeter/setSelectTmListTabIndex", 4);
    } else {
      /** 基準値超過タブのセット */
      this.$store.commit("Telemeter/setSelectTmListTabIndex", 2);
    }
  },
};
</script>

<style lang="scss" scoped></style>
